// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const CALLS = [
  { id:1, date:"2026-02-07", time:"4:30 PM", contact:"Mike Thompson", company:"Canstorr Commodities", direction:"Outbound", duration:"18 min", outcome:"Connected", notes:"Discussed Phase 2 timeline. Awaiting legal review.", followUp:"Send revised proposal by Feb 10", caller:"Lucas Mason" },
  { id:2, date:"2026-02-07", time:"3:15 PM", contact:"Sarah Chen", company:"Western Mining Corp", direction:"Inbound", duration:"25 min", outcome:"Connected", notes:"Integration timeline discussion. IT team needs API docs.", followUp:"Send API documentation", caller:"Lee Mehling" },
  { id:3, date:"2026-02-07", time:"2:00 PM", contact:"Dave Richards", company:"Northern Fleet Co", direction:"Outbound", duration:"12 min", outcome:"Connected", notes:"Onboarding check-in. All systems running smoothly.", followUp:"Schedule quarterly review", caller:"Lucas Mason" },
  { id:4, date:"2026-02-07", time:"11:30 AM", contact:"Jennifer Park", company:"BC Insurance Group", direction:"Outbound", duration:"0 min", outcome:"Voicemail", notes:"Left message about upcoming demo on Feb 14.", followUp:"Call back Feb 8 morning", caller:"Lucas Mason" },
  { id:5, date:"2026-02-07", time:"10:00 AM", contact:"Tom Williams", company:"Prairie Health Services", direction:"Inbound", duration:"8 min", outcome:"Connected", notes:"Quick question about user permissions. Resolved.", followUp:"None", caller:"Des Bachynski" },
  { id:6, date:"2026-02-06", time:"4:00 PM", contact:"Karen Liu", company:"Metro Beauty Collective", direction:"Outbound", duration:"22 min", outcome:"Connected", notes:"Trial setup discussion. Need 2 demo accounts.", followUp:"Set up trial by Feb 8", caller:"Lucas Mason" },
  { id:7, date:"2026-02-06", time:"2:30 PM", contact:"Mark Daniels", company:"AgriTech Farms", direction:"Inbound", duration:"15 min", outcome:"Connected", notes:"Sensor calibration question. Walked through process.", followUp:"None", caller:"Tyson Becker" },
  { id:8, date:"2026-02-06", time:"1:00 PM", contact:"Lisa Grant", company:"Investor Relations", direction:"Outbound", duration:"0 min", outcome:"No Answer", notes:"Tried to reach regarding Q4 investor update.", followUp:"Try again Feb 7", caller:"Ryan Miskulin" },
  { id:9, date:"2026-02-06", time:"10:30 AM", contact:"Robert Kim", company:"Mining Safety Board", direction:"Inbound", duration:"30 min", outcome:"Connected", notes:"Compliance requirements discussion for 2026.", followUp:"Send compliance checklist", caller:"Lee Mehling" },
  { id:10, date:"2026-02-05", time:"3:45 PM", contact:"Amy Foster", company:"Health Regulatory Body", direction:"Outbound", duration:"20 min", outcome:"Connected", notes:"Discussed 2026 regulatory changes affecting VitaSync.", followUp:"Update compliance docs", caller:"Des Bachynski" },
  { id:11, date:"2026-02-05", time:"2:00 PM", contact:"Chris Brown", company:"Canstorr Commodities", direction:"Outbound", duration:"0 min", outcome:"Callback Scheduled", notes:"Assistant said he's in meetings all day.", followUp:"Callback Feb 6 at 9 AM", caller:"Tyson Becker" },
  { id:12, date:"2026-02-05", time:"11:00 AM", contact:"Dan Murphy", company:"Fleet Insurance Co", direction:"Inbound", duration:"10 min", outcome:"Connected", notes:"Inquiry about fleet tracking integration with insurance.", followUp:"Send product info", caller:"Lucas Mason" },
  { id:13, date:"2026-02-04", time:"4:30 PM", contact:"Sandra Lee", company:"Tire Distribution Inc", direction:"Outbound", duration:"35 min", outcome:"Connected", notes:"Full product demo over the phone. Very interested.", followUp:"Send proposal", caller:"Lucas Mason" },
  { id:14, date:"2026-02-04", time:"1:00 PM", contact:"Paul Martinez", company:"Cattle Ranch Collective", direction:"Outbound", duration:"0 min", outcome:"No Answer", notes:"No pickup. Third attempt this week.", followUp:"Send email instead", caller:"Tyson Becker" },
  { id:15, date:"2026-02-03", time:"10:00 AM", contact:"Nancy White", company:"Real Estate Board", direction:"Inbound", duration:"14 min", outcome:"Connected", notes:"Interested in ClosingDesk for board members.", followUp:"Schedule group demo", caller:"Ryan Miskulin" }
];

const DIRECTIONS = ["All","Inbound","Outbound"];
const OUTCOMES = ["All","Connected","Voicemail","No Answer","Callback Scheduled"];

export default function CallLogPage() {
  const [calls] = useState(CALLS);
  const [directionFilter, setDirectionFilter] = useState("All");
  const [outcomeFilter, setOutcomeFilter] = useState("All");
  const [callerFilter, setCallerFilter] = useState("All");

  const callers = ["All", ...new Set(calls.map(c => c.caller))];

  const filtered = calls.filter(c => {
    if (directionFilter !== "All" && c.direction !== directionFilter) return false;
    if (outcomeFilter !== "All" && c.outcome !== outcomeFilter) return false;
    if (callerFilter !== "All" && c.caller !== callerFilter) return false;
    return true;
  });

  const todayCalls = calls.filter(c => c.date === "2026-02-07");
  const weekCalls = calls.filter(c => c.date >= "2026-02-03");
  const connected = calls.filter(c => c.outcome === "Connected");
  const avgMinutes = connected.length > 0 ? Math.round(connected.reduce((sum, c) => sum + parseInt(c.duration), 0) / connected.length) : 0;
  const connectRate = calls.length > 0 ? Math.round(connected.length / calls.length * 100) : 0;

  const outcomeBadge = (outcome) => {
    const map = { Connected:"badge badge-green", Voicemail:"badge badge-yellow", "No Answer":"badge badge-red", "Callback Scheduled":"badge badge-blue" };
    return map[outcome] || "badge";
  };

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Call Log</h1><p>Track and manage all phone communications</p></div>
        <button className="btn btn-primary">+ Log Call</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Calls Today</div><div className="stat-value">{todayCalls.length}</div></div>
        <div className="stat-card"><div className="stat-label">This Week</div><div className="stat-value">{weekCalls.length}</div></div>
        <div className="stat-card"><div className="stat-label">Avg Duration</div><div className="stat-value">{avgMinutes} min</div></div>
        <div className="stat-card"><div className="stat-label">Connect Rate</div><div className="stat-value" style={{color:"#10b981"}}>{connectRate}%</div></div>
      </div>

      <div style={{display:"flex",gap:12,marginBottom:16}}>
        <select className="input" value={directionFilter} onChange={e => setDirectionFilter(e.target.value)} style={{width:160}}>
          {DIRECTIONS.map(d => <option key={d} value={d}>{d === "All" ? "All Directions" : d}</option>)}
        </select>
        <select className="input" value={outcomeFilter} onChange={e => setOutcomeFilter(e.target.value)} style={{width:200}}>
          {OUTCOMES.map(o => <option key={o} value={o}>{o === "All" ? "All Outcomes" : o}</option>)}
        </select>
        <select className="input" value={callerFilter} onChange={e => setCallerFilter(e.target.value)} style={{width:200}}>
          {callers.map(c => <option key={c} value={c}>{c === "All" ? "All Team Members" : c}</option>)}
        </select>
      </div>

      <div className="card">
        <div className="card-header"><h3>Call Log</h3><span style={{fontSize:12,color:"#64748b"}}>{filtered.length} calls</span></div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{borderBottom:"2px solid #334155"}}>
                {["Date/Time","Contact","Company","Direction","Duration","Outcome","Notes","Follow-Up"].map(h => (
                  <th key={h} style={{textAlign:"left",padding:"10px 8px",fontSize:11,fontWeight:700,color:"#94a3b8",whiteSpace:"nowrap"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id} style={{borderBottom:"1px solid #334155"}}>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#e2e8f0",whiteSpace:"nowrap"}}><div>{c.date}</div><div style={{color:"#64748b"}}>{c.time}</div></td>
                  <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{c.contact}</td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{c.company}</td>
                  <td style={{padding:"10px 8px"}}><span className={c.direction==="Inbound"?"badge badge-blue":"badge badge-purple"}>{c.direction}</span></td>
                  <td style={{padding:"10px 8px",fontSize:13,color:c.duration==="0 min"?"#64748b":"#e2e8f0"}}>{c.duration === "0 min" ? "-" : c.duration}</td>
                  <td style={{padding:"10px 8px"}}><span className={outcomeBadge(c.outcome)}>{c.outcome}</span></td>
                  <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.notes}</td>
                  <td style={{padding:"10px 8px",fontSize:12,color:c.followUp==="None"?"#64748b":"#eab308"}}>{c.followUp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid-2" style={{marginTop:16}}>
        <div className="card">
          <div className="card-header"><h3>Calls by Outcome</h3></div>
          {["Connected","Voicemail","No Answer","Callback Scheduled"].map(outcome => {
            const count = calls.filter(c => c.outcome === outcome).length;
            const pct = calls.length ? (count / calls.length * 100) : 0;
            const colors = { Connected:"#10b981", Voicemail:"#eab308", "No Answer":"#ef4444", "Callback Scheduled":"#3b82f6" };
            return (
              <div key={outcome} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
                <span style={{fontSize:13,color:"#e2e8f0"}}>{outcome}</span>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:80,height:6,background:"#334155",borderRadius:3}}><div style={{width:pct+"%",height:6,background:colors[outcome],borderRadius:3}}/></div>
                  <span style={{fontSize:13,fontWeight:600,color:colors[outcome]}}>{count}</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="card">
          <div className="card-header"><h3>Calls by Team Member</h3></div>
          {[...new Set(calls.map(c => c.caller))].map(caller => {
            const count = calls.filter(c => c.caller === caller).length;
            return (
              <div key={caller} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
                <span style={{fontSize:13,color:"#e2e8f0"}}>{caller}</span>
                <span style={{fontSize:13,fontWeight:600,color:"#10b981"}}>{count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
